export const Layout = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="3" width="26" height="26" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M11 10L11 29" stroke="currentColor" stroke-width="2"/>
<path d="M4 11L28 11" stroke="currentColor" stroke-width="2"/>
</svg>`;
